module.exports = ".horizontal-center {\r\n  text-align: center;\r\n  display: block;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/features/my-financial/my-health-plan/my-health-plan.component.css
// module id = ./src/app/features/my-financial/my-health-plan/my-health-plan.component.css
// module chunks = main